//register plugins
gsap.registerPlugin(ScrollTrigger, ScrollToPlugin, ScrollSmoother, SplitText);
let globalAnimation = {
   animationEffects: function(e) {
      // 1 - loading
      if (document.querySelector(".loading-panels") != null) {
         const loader = gsap.timeline({
            paused: true,
         });
         loader.to(".loading-panels .loading-panel:first-child, .loading-panels .loading-panel:last-child", {
            scaleY: 1,
            duration: 1,
         }).to(".loading-panels .loading-panel:not(:first-child):not(:last-child)", {
            scaleY: 1,
         }, "-=0.5").to(".loading-panels .loading-panel", {
            scaleY: 0,
            duration: 0.3,
            stagger: 0.05,
         }).to(".loading-panels", {
            clipPath: "circle(0%)",
            skewX: 0,
            duration: 1,
         }).to(".atom-theme", {
            clipPath: "(100%)",
            duration: 1,
         }, "-=0.3");
         window.addEventListener("load", function() {
            loader.play();
         });
         window.addEventListener("resize", function() {
            if(document.querySelector('.loading-panels') != null){
              document.querySelector('.loading-panels').style.display = 'none';
            }
         });
      }
      // 2 - animate sections
      if (document.body.getAttribute("id") != "product") {
         if (document.body.getAttribute("id") != "collection") {
            var shopifySections = gsap.utils.toArray(".shopify-section");
            if (shopifySections != null) {
               gsap.set(".shopify-section", {
                  clearProps: true
               });
               gsap.set(shopifySections, {
                  className: "animation-applied-element",
               });
               ScrollTrigger.matchMedia({
                  "(min-width: 768px)": function() {
                     shopifySections.forEach((sectionItem, i) => {
                        if (sectionItem.querySelector("header") == null && sectionItem.querySelector(".main-footer") == null) {
                           var anim1 = gsap.fromTo(sectionItem, {
                              autoAlpha: 0,
                              y: 150,
                           }, {
                              duration: 1,
                              autoAlpha: 1,
                              y: 0,
                           });
                           ScrollTrigger.create({
                              trigger: sectionItem,
                              animation: anim1,
                              start: "top 100%",
                              end: "top 50%",
                              markers: false,
                              scrub: 1.5,
                           });
                        }
                     });
                  },
               });
            }
         }
      }
      //3 - welcome text animation
      if (document.querySelector(".js-section-title") != null) {
         gsap.set(".js-section-title", {
            clearProps: true
         });
         ScrollTrigger.matchMedia({
            "(min-width: 768px)": function() {
               let welcomeText = gsap.utils.toArray(".js-section-title");
               const sectionTitle = gsap.timeline({
                  scrollTrigger: {
                     trigger: welcomeText,
                     start: "top 90%",
                     end: "bottom 60%",
                     scrub: 2,
                     markers: false,
                     toggleActions: "play none play reset",
                  },
               });
               const welcomeSplit = new SplitText(welcomeText, {
                  type: "lines",
               });
               sectionTitle.from(welcomeSplit.lines, {
                  y: 100,
                  opacity: 0,
                  stagger: 0.05,
                  duration: 0.5,
                  ease: "back.inOut",
               });
            },
         });
      }
      //4 - product description animation
      if (document.querySelector(".section-product-tabs") != null && Shopify.designMode != true) {
         let splitTextLines = gsap.utils.toArray(".product-overview__text");
         gsap.set(".product-overview__text", {
            clearProps: true
         });
         ScrollTrigger.matchMedia({
            "(min-width: 768px)": function() {
               const tl = gsap.timeline({
                  scrollTrigger: {
                     trigger: splitTextLines,
                     start: "top 90%",
                     end: "top 20%",
                     scrub: 2,
                     markers: false,
                     toggleActions: "play none play reset",
                  },
               });
               const itemSplitted = new SplitText(splitTextLines, {
                  type: "lines",
               });
               tl.from(itemSplitted.lines, {
                  y: 100,
                  opacity: 0,
                  stagger: 0.05,
                  duration: 0.5,
                  ease: "back.inOut",
               });
            },
         });
      }
      // 5 - product page scroll effect media
      if (document.body.getAttribute("id") == "product") {
         var addHeight = 0;
         if (e.type == 'shopify:section:load') {
            addHeight = document.querySelector("#product-info").offsetHeight;
            console.log(addHeight);
         }
         if (e.type == "click") {
            addHeight = document.querySelector("#product-info").offsetHeight;
         }
         gsap.set("#product-media", {
            clearProps: true
         });
         gsap.set("#product-info", {
            clearProps: true
         });
         ScrollTrigger.matchMedia({
            "(min-width: 768px)": function() {
               var section = document.querySelector("#product-media");
               var anim = gsap.fromTo(section, {
                  y: 10,
               }, {
                  duration: 0.5,
                  y: 0,
                  ease: "power4.out",
               });
               ScrollTrigger.create({
                  trigger: section,
                  animation: anim,
                  top: "top 0%",
                  end: (self) => "+=" + (document.querySelector("#product-media").offsetHeight - addHeight - self.pin.offsetHeight),
                  pin: "#product-info",
                  onRefresh: (self) => (self.pin.parentNode.style.float = "left"),
                  pinSpacing: false,
                  anticipatePin: 1,
                  markers: false,
                  scrub: 2,
               });
            },
         });
         // 6 - scrolltrigger for each section
         var sections = gsap.utils.toArray(".shopify-section");
         if (sections != null) {
            gsap.set(".shopify-section", {
               clearProps: true
            });
            sections.forEach((section, i) => {
               if (section.querySelector("#product-form") == null && section.querySelector(".shopify-section-group-footer-group") != null && section.querySelector("header") == null) {
                  ScrollTrigger.matchMedia({
                     "(min-width: 768px)": function() {
                        var anim = gsap.fromTo(section, {
                           autoAlpha: 0,
                           y: 150,
                        }, {
                           duration: 1,
                           autoAlpha: 1,
                           y: 0,
                        });
                        ScrollTrigger.create({
                           trigger: section,
                           animation: anim,
                           start: "top 100%",
                           end: "top 60%",
                           markers: false,
                           scrub: 1.5,
                        });
                     },
                  });
               }
            });
         }
      }
      // 7 - Entire site scroll
      if (document.querySelector(".main-container") != null && document.querySelector(".main-sidebar") != null) {
         gsap.set(".main-container", {
            clearProps: true
         });
         gsap.set(".main-sidebar", {
            clearProps: true
         });
         ScrollTrigger.matchMedia({
            "(min-width: 768px)": function() {
               let triggers = ScrollTrigger.getAll();
               triggers.forEach((trigger) => {
                  var triggers = trigger.vars.trigger;
                  if (triggers == ".main-container") {
                     trigger.kill();
                  }
               });
               gsap.set(".main-sidebar .left-side", {
                  x: 0
               });
               gsap.registerPlugin(ScrollTrigger, ScrollSmoother);
               ScrollSmoother.create({
                  content: ".main-container",
                  smooth: 2,
                  effects: false,
                  smoothTouch: 1.5,
               });
               ScrollTrigger.create({
                  trigger: ".main-container",
                  start: "top top",
                  pin: ".main-sidebar",
                  anticipatePin: 1,
                  normalizeScroll: true,
                  pinSpacing: false,
               });
            },
         });
      }
      // flicker debugger
      window.addEventListener("load", (event) => {
         var flickerSelectors = ['.main-sidebar', '.collection-sorting.filter-wrapper', '#product-info', '.product-grid', '#page-cart'];
         flickerSelectors.forEach(function(sl, index) {
            var item = document.querySelector(sl);
            console.log('loading js', item);
            if (item != null) {
               item.style.setProperty('will-change', 'transform, opacity');
            }
         });
      });
      window.addEventListener("load", (event) => {
         var productImgDsk = ['.product-media-desktop-only'];
         productImgDsk.forEach(function(item, index) {
            var productItem = document.querySelector(item);
            console.log('loading js', productItem);
            if (productItem != null) {
               productItem.style.setProperty('will-change', 'transform, opacity');
            }
         });
      });
      // 8 - Marquee text effect
      //window.addEventListener("load", (event) => {
      // let links = document.querySelectorAll(".main-logo-slide");
      // let marquee = document.querySelector('.main-logo-slides');
      var marquees = document.querySelectorAll('.main-logo-slides');
      if (marquees.length > 0) {
         marquees.forEach(function(marquee) {
            var marqueeWrapper = marquee.closest('.scrolling-cta-wrapper');
            var links = marquee.querySelectorAll(".main-logo-slide");
            if (links.length > 0) {
               // assign the timeline returned from the helper function to 'loop'
               let loop = horizontalLoop(links, {
                  repeat: -1,
                  speed: 1 + 0.5,
                  draggable: true,
                  reversed: false,
                  paddingRight: parseFloat(gsap.getProperty(links[0], "marginRight", "px"))
               });
               // handle the timeline on hover
               if (marqueeWrapper != null) {
                  marquee.addEventListener("mouseenter", () => {
                     loop.pause()
                  });
                  marquee.addEventListener("mouseleave", () => {
                     loop.play()
                  });
               }
               // handle the timeline on scroll
               let currentScroll = 0;
               let scrollDirection = 1;
               window.addEventListener("scroll", () => {
                  let direction = window.pageYOffset > currentScroll ? 1 : -1;
                  if (direction !== scrollDirection) {
                     gsap.to(loop, {
                        timeScale: direction,
                        overwrite: true
                     });
                     scrollDirection = direction;
                  }
                  currentScroll = window.pageYOffset;
               });
            }
         });
      }

      function horizontalLoop(items, config) {
         if (items[0] != null) {
            items = gsap.utils.toArray(items);
            config = config || {};
            let tl = gsap.timeline({
                  repeat: config.repeat,
                  paused: config.paused,
                  defaults: {
                     ease: "none"
                  },
                  onReverseComplete: () => tl.totalTime(tl.rawTime() + tl.duration() * 100)
               }),
               length = items.length,
               startX = items[0].offsetLeft,
               times = [],
               widths = [],
               xPercents = [],
               curIndex = 0,
               pixelsPerSecond = (config.speed || 1) * 100,
               snap = config.snap === false ? (v) => v : gsap.utils.snap(config.snap || 1), // some browsers shift by a pixel to accommodate flex layouts, so for example if width is 20% the first element's width might be 242px, and the next 243px, alternating back and forth. So we snap to 5 percentage points to make things look more natural
               populateWidths = () => items.forEach((el, i) => {
                  widths[i] = parseFloat(gsap.getProperty(el, "width", "px"));
                  xPercents[i] = snap(
                     (parseFloat(gsap.getProperty(el, "x", "px")) / widths[i]) * 100 + gsap.getProperty(el, "xPercent"));
               }),
               getTotalWidth = () => items[length - 1].offsetLeft + (xPercents[length - 1] / 100) * widths[length - 1] - startX + items[length - 1].offsetWidth * gsap.getProperty(items[length - 1], "scaleX") + (parseFloat(config.paddingRight) || 0),
               totalWidth,
               curX,
               distanceToStart,
               distanceToLoop,
               item,
               i;
            populateWidths();
            gsap.set(items, {
               // convert "x" to "xPercent" to make things responsive, and populate the widths/xPercents Arrays to make lookups faster.
               xPercent: (i) => xPercents[i]
            });
            gsap.set(items, {
               x: 0
            });
            totalWidth = getTotalWidth();
            for (i = 0; i < length; i++) {
               item = items[i];
               curX = (xPercents[i] / 100) * widths[i];
               distanceToStart = item.offsetLeft + curX - startX;
               distanceToLoop = distanceToStart + widths[i] * gsap.getProperty(item, "scaleX");
               tl.to(item, {
                  xPercent: snap(((curX - distanceToLoop) / widths[i]) * 100),
                  duration: distanceToLoop / pixelsPerSecond
               }, 0).fromTo(item, {
                  xPercent: snap(
                     ((curX - distanceToLoop + totalWidth) / widths[i]) * 100)
               }, {
                  xPercent: xPercents[i],
                  duration: (curX - distanceToLoop + totalWidth - curX) / pixelsPerSecond,
                  immediateRender: false
               }, distanceToLoop / pixelsPerSecond).add("label" + i, distanceToStart / pixelsPerSecond);
               times[i] = distanceToStart / pixelsPerSecond;
            }

            function toIndex(index, vars) {
               vars = vars || {};
               Math.abs(index - curIndex) > length / 2 && (index += index > curIndex ? -length : length); // always go in the shortest direction
               let newIndex = gsap.utils.wrap(0, length, index),
                  time = times[newIndex];
               if (time > tl.time() !== index > curIndex) {
                  // if we're wrapping the timeline's playhead, make the proper adjustments
                  vars.modifiers = {
                     time: gsap.utils.wrap(0, tl.duration())
                  };
                  time += tl.duration() * (index > curIndex ? 1 : -1);
               }
               curIndex = newIndex;
               vars.overwrite = true;
               return tl.tweenTo(time, vars);
            }
            tl.next = (vars) => toIndex(curIndex + 1, vars);
            tl.previous = (vars) => toIndex(curIndex - 1, vars);
            tl.current = () => curIndex;
            tl.toIndex = (index, vars) => toIndex(index, vars);
            tl.updateIndex = () => (curIndex = Math.round(tl.progress() * (items.length - 1)));
            tl.times = times;
            tl.progress(1, true).progress(0, true); // pre-render for performance
            if (config.reversed) {
               tl.vars.onReverseComplete();
               tl.reverse();
            }
            if (config.draggable && typeof Draggable === "function") {
               let proxy = document.createElement("div"),
                  wrap = gsap.utils.wrap(0, 1),
                  ratio,
                  startProgress,
                  draggable,
                  dragSnap,
                  roundFactor,
                  align = () => tl.progress(wrap(startProgress + (draggable.startX - draggable.x) * ratio)),
                  syncIndex = () => tl.updateIndex();
               typeof InertiaPlugin === "undefined" && console.warn("InertiaPlugin required for momentum-based scrolling and snapping. https://greensock.com/club");
               draggable = Draggable.create(proxy, {
                  trigger: items[0].parentNode,
                  type: "x",
                  onPress() {
                     startProgress = tl.progress();
                     tl.progress(0);
                     populateWidths();
                     totalWidth = getTotalWidth();
                     ratio = 1 / totalWidth;
                     dragSnap = totalWidth / items.length;
                     roundFactor = Math.pow(10, ((dragSnap + "").split(".")[1] || "").length);
                     tl.progress(startProgress);
                  },
                  onDrag: align,
                  onThrowUpdate: align,
                  inertia: true,
                  snap: (value) => {
                     let n = Math.round(parseFloat(value) / dragSnap) * dragSnap * roundFactor;
                     return (n - (n % 1)) / roundFactor;
                  },
                  onRelease: syncIndex,
                  onThrowComplete: () => gsap.set(proxy, {
                     x: 0
                  }) && syncIndex()
               })[0];
            }
            return tl;
         }
      }
      //});
   }
};
//events
if (Shopify.designMode != true) {
   document.addEventListener("DOMContentLoaded", function(e) {
      globalAnimation.animationEffects(e);
   });
   document.addEventListener("shopify:section:load", function(e) {
      globalAnimation.animationEffects(e);
   });
   document.addEventListener("shopify:section:unload", function(e) {
      globalAnimation.animationEffects(e);
   });
   document.addEventListener("shopify:section:reorder", function(e) {
      globalAnimation.animationEffects(e);
   });
   document.addEventListener("DOMContentLoaded", function() {
      var checkbox = document.querySelector(".RecipientCheckbox");
      if (checkbox != null) {
         checkbox.addEventListener("click", function(e) {
            globalAnimation.animationEffects(e);
         });
      }
   });
}
if (Shopify.designMode == true) {
   var infoWrapWidth = document.querySelector("#product-info").offsetWidth;
   document.onscroll = function() {
      stickyProductMediaSection();
   };
   function stickyProductMediaSection() {
      var mediaWrap = document.querySelector("#product-media");
      var infoWrap = document.querySelector("#product-info");
      if (mediaWrap != null && infoWrap != null) {
         var row = infoWrap.closest(".row");
         if (window.innerWidth > 767) {
            var hm = mediaWrap.offsetHeight;
            var hi = infoWrap.offsetHeight;
            var diffmi = hm - hi;
            if (hm > hi) {
               infoWrap.style.position = "fixed";
               infoWrap.style.setProperty("width", infoWrapWidth + "px", "");
               var rect = mediaWrap.getBoundingClientRect();
               var scrolledMedia = -rect.top;
               console.log(scrolledMedia, diffmi);
               if (scrolledMedia >= diffmi) {
                  infoWrap.style.position = "relative";
                  row.style.setProperty("align-items", "end", "");
                  infoWrap.style.removeProperty("top");
               } else if (scrolledMedia < diffmi) {
                  infoWrap.style.position = "fixed";
                  row.style.removeProperty("align-items");
                  infoWrap.style.setProperty("top", "0", "");
               }
               if (Math.sign(scrolledMedia) == -1) {
                  infoWrap.style.position = "relative";
                  row.style.removeProperty("align-items");
                  infoWrap.style.removeProperty("top");
                  infoWrap.style.removeProperty("width");
               }
            }
         } else {
            infoWrap.style.position = "relative";
            row.style.removeProperty("align-items");
            infoWrap.style.removeProperty("top");
            infoWrap.style.removeProperty("width");
         }
      }
   }
}
